import ViewportComponent from 'Component/Map/Viewport';
import GameObject from 'GameObject/GameObject';
import Point from 'Utility/Point';
import TransformComponent from 'Component/Transform';
import Renderable from 'Component/Renderable';
import Interactable from 'Component/Interactable';
import IWorldSettings from 'System/World/Data/IWorldSettings';
import SagaMapComponent from 'Component/Map/SagaMapComponent';
import LevelNode from './LevelNode/LevelNode';
import Viewport from '../Viewport';
import { defaultCanvasSize } from 'Constants/Canvas';
import PIXIRenderer from 'System/Render/PIXIRenderer';

export enum SagaMapContainers {
    FRIEND_ICON_CONTAINER = 'friend_icon_container',
    MAP_COMPONENTS_CONTAINER = 'map_components_container',
    PLAYER_ICON = 'player_icon',
    PET_CONTAINER = 'pet_container',
    LUCKY_WHEEL_CONTAINER = 'lucky_wheel_container',
    SIGN_BUBBLES_CONTAINER = 'sign_bubbles_container',
    PLINKO_INDICATOR_CONTAINER = 'plinko_indicator_container',
}

export default class WorldMap extends Viewport {
    private static width: number;
    private static height: number = defaultCanvasSize.y;
    private worldLayout: any;

    public static get Width(): number {
        return this.width || 0;
    }
    public static get Height(): number {
        return this.height || 0;
    }
    public onCreate(params: { worldLayout: any; worldSettings: IWorldSettings; position: Point; tileCount: number }) {
        this.name = 'world_map';
        this.worldLayout = params.worldLayout;
        this.addChild(params.worldLayout.root);

        WorldMap.width = params.worldLayout.backgrounds.children
            .slice(0, params.tileCount)
            .map((c: GameObject) => c.getComponent(TransformComponent).width)
            .reduce((acc: number, v: number) => acc + v, 0);

        this.addComponent<ViewportComponent>(ViewportComponent, {
            drag: {
                direction: 'x',
            },
            decelerate: { friction: 0 },
            clamp: { direction: 'all' },
        });

        PIXIRenderer.mapViewport = this.container;

        PIXIRenderer.mapViewport.position.set(
            this.container.x + PIXIRenderer.renderer.width * 0.5,
            this.container.y + PIXIRenderer.renderer.height * 0.5
        );

        PIXIRenderer.resizeViewport(PIXIRenderer.renderer.width, PIXIRenderer.renderer.height);

        this.addComponent<SagaMapComponent>(SagaMapComponent, params);
        const transform = this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);
        this.addComponent<Interactable>(Interactable, params);
    }

    public get friendIconContainer(): GameObject {
        return this.children.find(child => child.name === SagaMapContainers.FRIEND_ICON_CONTAINER);
    }

    public get levelContainer(): GameObject {
        return this.worldLayout.nodesContainer;
    }

    public get petContainer(): GameObject {
        return this.find(SagaMapContainers.PET_CONTAINER);
    }

    public get luckyWheelContainer(): GameObject {
        return this.find(SagaMapContainers.LUCKY_WHEEL_CONTAINER);
    }

    public get mapComponentContainer(): GameObject {
        return this.children.find(child => child.name === SagaMapContainers.MAP_COMPONENTS_CONTAINER);
    }

    public get playerIcon(): GameObject {
        return this.children.find(child => child.name === SagaMapContainers.PLAYER_ICON);
    }

    public get signBubblesContainer(): GameObject {
        return this.children.find(child => child.name === SagaMapContainers.SIGN_BUBBLES_CONTAINER);
    }

    public get levelNodes(): Map<number, LevelNode> {
        const sagaMapComponent: SagaMapComponent = this.getComponent<SagaMapComponent>(SagaMapComponent);
        return sagaMapComponent && sagaMapComponent.levelNodes ? sagaMapComponent.levelNodes : undefined;
    }
}
